import { gql } from '@apollo/client';

export const GET_USER_INFO = gql`
  query GetUserInfo {
    getUserInfo {
      email
      familyName
      firstName
      givenName
      lastName
      roles
      userId
      userType
      permissions {
        applicationName
        permissions
      }
      region
      preferredName
      sub
      distributorCodes
    }
  }
`;
